import { render, staticRenderFns } from "./SkeletonBasePriceComponent.vue?vue&type=template&id=b9e9befc&scoped=true&"
import script from "./SkeletonBasePriceComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonBasePriceComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonBasePriceComponent.vue?vue&type=style&index=0&id=b9e9befc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e9befc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
